import _ from 'underscore';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { UiBlocker } from '@bingads-webui-react/ui-blocker';

import { getStyles } from './get-styles';
import { footerConfigProp, StepFooter } from './step-footer';

const StepContainerUnstyled = (props) => {
  const {
    title,
    step,
    footerConfig,
    isLoading,
    children,
    classes,
  } = props;

  const i18n = useContext(I18nContext);

  return (
    <UiBlocker
      blocking={isLoading}
      loadingText={i18n.getString(_TL_('Loading...'))}
    >
      <div className={classNames('conversion-wizard-step', step, classes.stepContainer)}>
        <h1 className={classNames('step-header', classes.title)} id={`${step}-title`}>
          {title}
        </h1>
        <main className={classNames('step-content', classes.stepContent)} >
          {children}
        </main >
        <StepFooter config={footerConfig} />
      </div>
    </UiBlocker>
  );
};


StepContainerUnstyled.propTypes = {
  classes: PropTypes.shape(_.mapObject(getStyles(), _.constant(PropTypes.string.isRequired)))
    .isRequired,
  title: PropTypes.string.isRequired,
  step: PropTypes.string.isRequired,
  footerConfig: footerConfigProp.isRequired,
  isLoading: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

StepContainerUnstyled.defaultProps = {
  isLoading: false,
};

export const StepContainer = withDefaultStyles(StepContainerUnstyled, getStyles);
